var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPieChart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 17169",
    width: 30,
    height: 30,
    rx: 5,
    transform: "translate(344 300)",
    fill: "#3b5175",
    stroke: "#707070"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Mask Group 1387",
    transform: "translate(-344 -300)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "invisible box"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 17178",
    fill: "none",
    d: "M344 300h30v30h-30z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "icons Q2",
    fill: "#3b5175"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21493",
    d: "M357.75 313.75H346.5a1.25 1.25 0 0 1-1.25-1.25 11.312 11.312 0 0 1 11.25-11.25 1.25 1.25 0 0 1 1.25 1.25Zm-9.937-2.5h7.437v-7.437a8.875 8.875 0 0 0-7.438 7.437Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21494",
    d: "M361.5 328.75a11.187 11.187 0 0 1-8.312-3.687 11.562 11.562 0 0 1-2.938-7.813 1 1 0 0 1 1-1h9v-9.062a.938.938 0 0 1 .938-.937 11.875 11.875 0 0 1 8.062 3.062A11.25 11.25 0 0 1 362 328.75Zm-8.687-10a8.875 8.875 0 0 0 2.625 5.063 8.625 8.625 0 0 0 6.5 2.437 8.812 8.812 0 0 0 8.313-8.312 8.625 8.625 0 0 0-2.438-6.5 8.875 8.875 0 0 0-5.063-2.625v8.687a1.25 1.25 0 0 1-1.25 1.25Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPieChart);
export default __webpack_public_path__ + "static/media/pie-chart.7f7b93cf8ca2c2c51b872e552c1946a2.svg";
export { ForwardRef as ReactComponent };